import { getTaskScenarioMeta } from './scenarioMapping';

export interface TaskCampaignFilters {
  readonly FormTemplateIds?: string[];
  readonly FormBatchIds?: string[];
  readonly DispensarizationBatchIds?: string[];
}

export const getTaskCampaignGroups = (types: readonly string[]) => {
  const groups = types.map((type) => getTaskScenarioMeta(type).group);
  const eligible = groups.every(
    (group) => group === 'form' || group === 'dispensarization',
  );
  return {
    form: eligible && groups.includes('form'),
    dispensarization: eligible && groups.includes('dispensarization'),
  };
};

export const retainTaskCampaignFilters = (
  types: readonly string[],
  filters: TaskCampaignFilters,
): TaskCampaignFilters => {
  const groups = getTaskCampaignGroups(types);
  return {
    FormTemplateIds: groups.form ? filters.FormTemplateIds : undefined,
    FormBatchIds: groups.form ? filters.FormBatchIds : undefined,
    DispensarizationBatchIds: groups.dispensarization
      ? filters.DispensarizationBatchIds
      : undefined,
  };
};
